import _ from 'underscore';

const errorObjectToString = (err) => {
  const { name, message, stack } = err;
  if (message || stack) {
    return `Error: ${name}, message: ${message}, stack: ${stack}`;
  }
  return JSON.stringify(err) || '(no error message)';
};

export const getErrorString = (err) => {
  if (!err) {
    return '';
  }

  if (_.isString(err)) {
    return err;
  }

  if (_.isObject(err)) {
    let msg = errorObjectToString(err);
    if (err.originError) {
      msg += `,\r\nOrigin ${errorObjectToString(err.originError)}`;
    }
    return msg;
  }

  return JSON.stringify(err);
};
